import clsx from 'clsx';
import { useCallback } from 'react';

import { FormElementText } from '~components/generic/editor/FormElementText';
import useLabels from '~hooks/useLabels';
import { IEntityComponentProps } from '~interfaces/props';
import { getModuleUrlIdFromData } from '~services/location-helpers';
import isValidHttpUrl from '~utils/isValidHttpUrl';
import { Iframe } from './Iframe';
import styles from './IFrame.module.css';

export const ModuleIframe = ({ data, editing, className, onChange }: IEntityComponentProps) => {
  const { placeholderModuleAttributeIframeSrc, labelModuleAttributeIframeSrc } = useLabels([
    'labelModuleAttributeIframeSrc',
    'placeholderModuleAttributeIframeSrc',
  ]);

  const handleChange = useCallback(
    (fieldName: string) => (value: string) => {
      onChange(fieldName, value);
    },
    [onChange],
  );
  const handleSrcChange = handleChange('attributes.field_link_external.uri');

  // Do not render if there is no data!
  if (!data) {
    return null;
  }

  // Get field values
  const fieldSrcValue: string = data.attributes.field_link_external?.uri || '';
  const fieldShowBorderValue: boolean = Boolean(data.attributes.field_show_border) || false;
  const fieldMinSizeValue: number = data.attributes.field_min_size || 500;

  // derived values
  const isUrlValid = isValidHttpUrl(fieldSrcValue);

  // ClassName generation
  const clsModule = clsx({ ...className.module });
  const clsContainer = clsx('relative px-0', { ...className.container });
  const clsFrameContainer = clsx(
    'col col-12 d-flex iframe-container',
    fieldShowBorderValue && 'border',
    fieldShowBorderValue && styles.border,
  );

  return (
    <div className={clsModule} id={getModuleUrlIdFromData(data.id, data.type)}>
      <div className={clsContainer}>
        {editing ? (
          <div className="row c-module__header">
            <div className="col u-margin-bottom-md">
              <div className="u-margin-vertical-sm">
                <FormElementText
                  value={fieldSrcValue}
                  onChange={handleSrcChange}
                  label={labelModuleAttributeIframeSrc}
                  placeholder={placeholderModuleAttributeIframeSrc}
                />
              </div>
            </div>
          </div>
        ) : (
          <article className="row no-gutters">
            {!!fieldSrcValue && isUrlValid && (
              <section className={clsFrameContainer}>
                <Iframe src={fieldSrcValue} minHeight={fieldMinSizeValue} />
              </section>
            )}
          </article>
        )}
      </div>
    </div>
  );
};

export default ModuleIframe;
